import { ModalDelete } from "expano-components";
import { deleteSpeditor } from "actions/speditors";

import { useMainList } from "components/MainList/context/provider";

const ModalDeleteSpeditor = ({ id, name, handleClose }) => {
  const { refetch } = useMainList();

  const onDelete = async () => {
    try {
      await deleteSpeditor(id);
      refetch();
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ModalDelete
      handleDelete={onDelete}
      handleClose={handleClose}
      name={`spedytora ${name}?`}
    />
  );
};

export default ModalDeleteSpeditor;
